
import { dateRangeUriEncode } from 'utils/Utils';

const channelLangUriEncode = (channel, language) => {
    const params = [];
    if (channel)  params.push(`channel=${channel}`);
    if (language) params.push(`language=${language}`);
    return params.join('&');
};

class AnalyticsService {

    getOverview = (dateRanges, channel, language) => {
        return {
            method: 'get',
            url: `/analytics/overview?${dateRangeUriEncode(dateRanges)}&${channelLangUriEncode(channel, language)}`,
        }
    }

    getConversationsByService = (dateRanges, channel, language) => {
        return {
            method: 'get',
            url: `/analytics/services?${dateRangeUriEncode(dateRanges)}&${channelLangUriEncode(channel, language)}`,
        }
    }

    getConverstationsPerDay = (dateRanges, channel, language) => {
        return {
            method: 'get',
            url: `/analytics/conversations?${dateRangeUriEncode(dateRanges)}&${channelLangUriEncode(channel, language)}`,
        }
    }

    getMessagesByType = (dateRanges, channel, language) => {
        return {
            method: 'get',
            url: `/analytics/types?${dateRangeUriEncode(dateRanges)}&${channelLangUriEncode(channel, language)}`,
        }
    }


    getMessagesByLanguage = (dateRanges, channel, language) => {
        return {
            method: 'get',
            url: `/analytics/languages?${dateRangeUriEncode(dateRanges)}&${channelLangUriEncode(channel, language)}`,
        }
    }

    getMessagesPerDay = (dateRanges, channel, language) => {
        return {
            method: 'get',
            url: `/analytics/messages?${dateRangeUriEncode(dateRanges)}&${channelLangUriEncode(channel, language)}`,
        }
    }


    getOriginDestinaion = (dateRanges, channel, language) => {
        return {
            method: 'get',
            url: `/analytics/od?${dateRangeUriEncode(dateRanges)}&${channelLangUriEncode(channel, language)}`,
        }
    }

    // KPI endpoints
    getConversationsKpi = (dateRanges, channel, language) => ({
        method: 'get',
        url: `/analytics/conversations?${dateRangeUriEncode(dateRanges)}&${channelLangUriEncode(channel, language)}`,
    })

    getUniqueUsers = (dateRanges, channel, language) => ({
        method: 'get',
        url: `/analytics/unique-users?${dateRangeUriEncode(dateRanges)}&${channelLangUriEncode(channel, language)}`,
    })

    getTopIntents = (dateRanges, channel, language) => ({
        method: 'get',
        url: `/analytics/top-intents?${dateRangeUriEncode(dateRanges)}&${channelLangUriEncode(channel, language)}`,
    })

    getEscalationRate = (dateRanges, channel, language) => ({
        method: 'get',
        url: `/analytics/escalation-rate?${dateRangeUriEncode(dateRanges)}&${channelLangUriEncode(channel, language)}`,
    })

    getAvgResponseTime = (dateRanges, channel, language) => ({
        method: 'get',
        url: `/analytics/avg-response-time?${dateRangeUriEncode(dateRanges)}&${channelLangUriEncode(channel, language)}`,
    })

    getConversationQuality = (dateRanges, channel, language) => ({
        method: 'get',
        url: `/analytics/conversation-quality?${dateRangeUriEncode(dateRanges)}&${channelLangUriEncode(channel, language)}`,
    })

}


const analyticsService = new AnalyticsService();
export default analyticsService;
